// let ipAddress = '192.168.6.137'
const port = '8043'
let printer = null // 印表機物件

/**
 * 嘗試連接印表機
 */
export const testPrinterConnection = async (ipAddress, retryCount = 5) => {
  const connectPrinter = async () => {
    let result = 'fail'
    return await new Promise(async (resolve) => {
      for (let i = 0; i < retryCount; i++) {
        try {
          const res = await connectEPOSDevice(ipAddress, port)
          result = res
          if (res === 'success') break
        } catch (e) {
          console.error(`connect fail: ${e}`)
        }
      }
      resolve(result)
    })
  }

  return await connectPrinter()
}

/**
 * 連結 EPOS 印表機裝置
 * @param {*} ipAddress
 * @param {*} port
 * @returns
 */
const connectEPOSDevice = async (ipAddress, port) => {
  const ePosDevCheck = new epson.ePOSDevice()
  return await new Promise((resolve) => {
    ePosDevCheck.connect(
      ipAddress,
      port,
      (data) => {
        if (data === 'OK' || data === 'SSL_CONNECT_OK') resolve('success')
        else resolve(data)
        // 斷開連接
        ePosDevCheck.disconnect()
      }
    )
  })
}

/**
 * 列印明細單
 * @param {number} templateVersion 模板版本
 * @param {string} ipAddress 印表機 IP
 * @param {Object} printData 列印資料
 * @param {string} title 標題
 */
export const printThermalPrinter = (templateVersion, ipAddress, printData = {}, title = '明細單\n') => {
  printer = null
  return new Promise((resolve, reject) => {
    const ePosDev = new epson.ePOSDevice()
    console.log('printThermalPrinter', ePosDev, templateVersion, ipAddress, printData)

    ePosDev.connect(ipAddress, port, (data) => {
      if (data === 'OK' || data === 'SSL_CONNECT_OK') {
        ePosDev.createDevice('local_printer', ePosDev.DEVICE_TYPE_PRINTER, { crypto: true, buffer: false }, async (devobj, retcode) => {
          if (retcode === 'OK') {
            printer = devobj
            printer.timeout = 60000
            try {
              switch (templateVersion) {
                case 1:
                  printTemplateV1(printData, title)
                  break
                case 2:
                  printTemplateV2(printData, title)
                  break
                case 3:
                  printTemplateV3(printData)
                  break
              }
            } catch (error) {
              reject(error)
              return
            }
            printer.onreceive = function (res) { console.log('Printer Object Created res', res) }
            printer.oncoveropen = function () { console.log('Printer Cover Open') }
            resolve()
          } else {
            console.error('printThermalPrinter error retcode', retcode)
            reject(retcode)
          }
        })
      } else {
        reject(data)
      }
    })
  })
}

/**
 * 列印模板V1
 */
const printTemplateV1 = (data, title, textSize = 'M') => {
  const totalPoint = data.item.reduce((a, b) => a + b.quantity * b.price, 0)
  const pointAfter = data.pointBefore - totalPoint
  let textWidth, textHeight, textLineSpace
  switch (textSize) {
    // 目前只會使用 M size 但以此方式預留擴充
    case 'S':
      // 原廠預設值
      [textWidth, textHeight] = [1, 1]
      textLineSpace = 0
      break
    case 'M':
      [textWidth, textHeight] = [1, 2]
      textLineSpace = 20
      break
    case 'L':
      [textWidth, textHeight] = [2, 2]
      textLineSpace = 20
      break
    default:
      // 原廠預設值
      [textWidth, textHeight] = [1, 1]
      textLineSpace = 0
      break
  }

  printer.addTextLang('zh-tw')
  printer.addTextSize(textWidth, textHeight)
  printer.addTextLineSpace(textLineSpace)

  printer.addTextAlign(printer.ALIGN_CENTER)
  printer.addText(`${title}\n\n`)

  printer.addTextAlign(printer.ALIGN_LEFT)
  printer.addText(`戶號：${data.userId}\n\n`)

  printer.addTextAlign(printer.ALIGN_RIGHT)
  printer.addText('品名 * 數量 ($單價) 金額\n\n')
  data.item.map((e) => {
    printer.addText(
      `${e.name} * ${e.quantity} (${e.price})  ${e.quantity * e.price}\n\n`
    )
  })
  printer.addText(`合計：${totalPoint}\n\n`)

  printer.addTextAlign(printer.ALIGN_LEFT)
  printer.addText(
    `交易前點數：${data.pointBefore}   交易後點數：${pointAfter}\n\n`
  )
  printer.addText(`服務員：${data.staff}\n\n`)
  printer.addText(`時間：${data.date}\n\n`)
  printer.addText('簽名：__________________________\n\n')

  printer.addCut(printer.CUT_FEED)
  printer.send()

  console.log('Print done!')
}

/**
 * 字型設定
 * 1. 排版時，「餐點品項名稱與數量、單價、金額」使用 FONT_A；而規格使用 FONT_B
 * 2. 當前的字型設定會決定一行可以放多少單位的內容(unitsPerLine)
 * 3. leftSideUnits 指得是左邊的單位數
 * [FONT_A]
 * 用於置放「餐點品項名稱與數量」，而「單價 金額」則是靠右對齊
 * 「單價 金額」目前給予的單位數是6，"50000  50000" (中間兩個空白) 共 12 個 0.5 單位 (12 * 0.5 = 6)
 * 而因為兩側中間要有間隔，所以左側空間給予 9 單位 (17.5 - 6 - 2 = 9.5)
 * [FONT_B]
 * 用於置放規格，為了大致與「餐點品項名稱與數量」對齊，所以給予 10.5 單位
 * 2025/04/08 註記(重要!!)：
 * 1. 因應使用者反饋字體太小，所以目前並沒有採用 FONT_B(而是 textSize = M)，而字元單位仍是採用 FONT_A 的設定
 */
const fontSetting = {
  fontA: { unitsPerLine: 17.5, leftSideUnits: 9.5, leftSidePaddingRight: 2, rightSideUnits: 6 },
  fontB: { unitsPerLine: 21, leftSideUnits: 10.5 }
}

/**
 * 印點數類型與交易前後點數
 * @param {*} pointType 點數類型
 * @param {*} before 交易前點數
 * @param {*} after 交易後點數
 */
const printPointLine = (pointType, before, after) => {
  // 將數字補足到5位數，不足的從前面補空白
  const paddedBefore = before.toString().padStart(5, ' ')
  const paddedAfter = after.toString().padStart(5, ' ')
  const rightSideContent = `${paddedBefore}${getContents(' ', 2)}${paddedAfter}`
  const rightSideRemainingUnits = fontSetting.fontA.rightSideUnits - getStringUnits(rightSideContent)
  /**
   * 計算填補的空白數
   * 左側剩餘: 9.5 - 4 = 5.5
   * 加上左側padding right: 5.5 + 2 = 7.5
   * 計算空白數量: 7.5 / 0.5 = 15
   * 然後再加上右側剩餘單位的空白數量: rightSideRemainingUnits / 0.5
   */
  const fillUnits = 15 + rightSideRemainingUnits / 0.5
  printer.addText(`${pointType}${getContents(' ', fillUnits)}${rightSideContent}\n`)
}

/**
 * 列印模板V2
 * 出單機型號：
 * EPSON TM-m10
 * 網頁模擬器：
 * https://xanhtool.github.io/epbex/
 * Setting頁籤：
 * Model, Paper width (Liner width)：TM-m10 series(58mm)
 * 目前依據模擬器的測試，Font 只採用以下設定：
 * Font A: 一行可以放 17.5 個單位
 * Font B: 一行可以放 21 個單位 (較小字型，用於呈現規格)
 * [Font B 實際列印時與 Font A 的字型大小相同，無法呈現較小字型]
 * 單位說明：
 * (1) 1個單位
 * 例如：中文字
 * (2) 0.5個單位(皆是指半形)
 * 例如：數字、符號、空白
 * 2025/04/08 註記(重要!!):
 * 1. 因應使用者反饋字體太小，所以目前字體依照舊版的設定方式(V1)，也就是 textSize = M
 * @param {object} data
 * @param {string} data.userId 戶號
 * @param {object[]} data.items 餐點品項列表
 * @param {boolean} data.isPointSupplement 是否啟用點數補足功能
 * @param {number} data.selectedPointType 選擇的交易點數類別
 * @param {number} data.normalPointBefore 一般點數(交易前)
 * @param {number} data.cashPointBefore 現金點數(交易前)
 * @param {number} data.normalPointAfter 一般點數(交易後)
 * @param {number} data.cashPointAfter 現金點數(交易後)
 * @param {string} data.staff 結單人員
 * @param {string} data.date 時間
 * @param {string | undefined} title
 * @param {string} textSize
 */
const printTemplateV2 = (data, title, textSize = 'M') => {
  // 設定字體大小
  let textWidth, textHeight
  switch (textSize) {
    // 目前只會使用 M size 但以此方式預留擴充
    case 'S':
      // 原廠預設值
      [textWidth, textHeight] = [1, 1]
      break
    case 'M':
      [textWidth, textHeight] = [1, 2]
      break
    case 'L':
      [textWidth, textHeight] = [2, 2]
      break
    default:
      // 原廠預設值
      [textWidth, textHeight] = [1, 1]
      break
  }
  // 設定語言
  printer.addTextLang('zh-tw')
  // 設定字體大小
  printer.addTextSize(textWidth, textHeight)
  // 單據標題
  printer.addTextAlign(printer.ALIGN_CENTER)
  printer.addText(`${title}\n`)
  printer.addFeedUnit(4) // 垂直間隔
  // 戶號
  printer.addText(`戶號：${data.userId}\n`)
  // 餐點品項欄位標題
  printer.addFeedUnit(20) // 垂直間隔
  printer.addTextAlign(printer.ALIGN_LEFT)
  printer.addText(`餐點品項/規格${getContents(' ', 13)}單價 金額\n`)
  printer.addFeedUnit(16) // 垂直間隔
  // 餐點品項列表
  for (let i = 0; i < data.items.length; i++) {
    // 目前餐點品項
    const currentItem = data.items[i]
    // 處理名稱與數量
    const originalItemTitle = `${currentItem.name}*${currentItem.quantity}`
    // 拆解餐點品項與數量
    const itemTitleSplit = getStringArray(originalItemTitle, fontSetting.fontA.leftSideUnits)
    /**
     * 先處理第一行的左右兩側內容
     * 1. 左側：餐點品項名稱與數量
     * 邏輯說明： 內容 + 補足左側剩餘可用單位數的空白 + 右側間隔空白
     * 2. 右側：單價 金額
     * 3. 左右兩側相加
     * 邏輯說明： 左側內容 + 補足右側剩餘可用單位數的空白 + 右側內容
     */
    const leftSideContent = `${itemTitleSplit[0]}${getContents(' ', (fontSetting.fontA.leftSideUnits - getStringUnits(itemTitleSplit[0])) / 0.5)}${getContents(' ', fontSetting.fontA.leftSidePaddingRight / 0.5)}`
    const rightSideContent = `${currentItem.price}${getContents(' ', 2)}${currentItem.quantity * currentItem.price}`
    printer.addText(`${leftSideContent}${getContents(' ', (fontSetting.fontA.rightSideUnits - rightSideContent.length * 0.5) / 0.5)}${rightSideContent}\n`)
    // 如果「餐點品項與數量」拆解結果超過一行，則接續打印
    if (itemTitleSplit.length > 1) {
      for (let i = 1; i < itemTitleSplit.length; i++) {
        printer.addText(`${itemTitleSplit[i]}\n`)
      }
    }
    // 處理規格
    printer.addFeedUnit(12) // 垂直間隔
    const itemSpecSplit = getStringArray(currentItem.displaySpec, fontSetting.fontA.leftSideUnits)
    for (let i = 0; i < itemSpecSplit.length; i++) {
      printer.addText(`${itemSpecSplit[i]}\n`)
    }
    printer.addText(`${getContents('.', fontSetting.fontA.unitsPerLine / 0.5)}\n`) // 加入分隔線
    printer.addFeedUnit(4) // 垂直間隔
  }
  printer.addTextAlign(printer.ALIGN_RIGHT)
  printer.addText(`合計：${data.totalPoint}\n`)
  printer.addFeedUnit(48) // 垂直間隔

  printer.addTextAlign(printer.ALIGN_LEFT)
  printer.addText(`點數類型${getContents(' ', 14)}交易前 交易後\n`)
  printer.addFeedUnit(36) // 垂直間隔

  if (data.isPointSupplement) {
    // 啟用點數補足：顯示兩種點數
    printPointLine('一般點數', data.normalPointBefore, data.normalPointAfter)
    printer.addFeedUnit(16) // 垂直間隔
    printPointLine('現金點數', data.cashPointBefore, data.cashPointAfter)
  } else {
    // 未啟用點數補足：根據選擇的點數類型顯示
    const pointType = data.selectedPointType === 1 ? '一般點數' : '現金點數'
    const before = data.selectedPointType === 1 ? data.normalPointBefore : data.cashPointBefore
    const after = data.selectedPointType === 1 ? data.normalPointAfter : data.cashPointAfter
    printPointLine(pointType, before, after)
  }

  printer.addFeedUnit(48) // 垂直間隔
  printer.addText(`服務員：${data.staff}\n`)
  printer.addFeedUnit(12) // 垂直間隔
  printer.addText(`時間：${data.date}\n`)
  printer.addFeedUnit(12) // 垂直間隔
  printer.addText(`簽名：${getContents('_', 20)}\n`)

  printer.addCut(printer.CUT_FEED)
  printer.send()

  console.log('Print done!')
}

/**
 * 列印模板V3
 * 1. 與 V2 版差異如下：
 * (1) 新增訂單編號
 * (2) 新增用餐方式
 * (3) 移除服務員 / 新增備註
 * (4) 部分呈現樣式調整
 * 更新日期：2026/03/27
 * @param {object} data
 * @param {string | undefined} title
 */
const printTemplateV3 = (data) => {
  // 設定語言
  printer.addTextLang('zh-tw')
  // 設定字體大小
  printer.addTextSize(1, 2)

  printer.addTextAlign(printer.ALIGN_CENTER)
  printer.addText(`明細單${data.isVoidOrCancel ? '(作廢/取消)' : ''}\n`)
  printer.addText(`${getContents('-', fontSetting.fontA.unitsPerLine / 0.5)}\n`) // 加入分隔線

  printer.addFeedUnit(8) // 垂直間隔
  printer.addTextAlign(printer.ALIGN_LEFT)
  printer.addText(`訂單：${data.comOrderId}\n`) // 訂單編號
  printer.addFeedUnit(8) // 垂直間隔
  printer.addText(`${data.dining}\n`) // 用餐方式
  printer.addFeedUnit(8) // 垂直間隔
  printer.addText(`戶號：${data.userId}\n`) // 戶號

  printer.addFeedUnit(20) // 垂直間隔
  printer.addTextAlign(printer.ALIGN_LEFT)
  printer.addText(`品項/規格${getContents(' ', 17)}單價 金額\n`) // 餐點品項欄位標題
  printer.addFeedUnit(16) // 垂直間隔
  // 餐點品項列表
  for (let i = 0; i < data.items.length; i++) {
    // 目前餐點品項
    const currentItem = data.items[i]
    // 處理名稱與數量
    const originalItemTitle = `${currentItem.name}*${currentItem.quantity}`
    // 拆解餐點品項與數量
    const itemTitleSplit = getStringArray(originalItemTitle, fontSetting.fontA.leftSideUnits)
    /**
     * 先處理第一行的左右兩側內容
     * 1. 左側：餐點品項名稱與數量
     * 邏輯說明： 內容 + 補足左側剩餘可用單位數的空白 + 右側間隔空白
     * 2. 右側：單價 金額
     * 3. 左右兩側相加
     * 邏輯說明： 左側內容 + 補足右側剩餘可用單位數的空白 + 右側內容
     */
    const leftSideContent = `${itemTitleSplit[0]}${getContents(' ', (fontSetting.fontA.leftSideUnits - getStringUnits(itemTitleSplit[0])) / 0.5)}${getContents(' ', fontSetting.fontA.leftSidePaddingRight / 0.5)}`
    const rightSideContent = `${currentItem.price}${getContents(' ', 2)}${currentItem.quantity * currentItem.price}`
    printer.addText(`${leftSideContent}${getContents(' ', (fontSetting.fontA.rightSideUnits - rightSideContent.length * 0.5) / 0.5)}${rightSideContent}\n`)
    // 如果「餐點品項與數量」拆解結果超過一行，則接續打印
    if (itemTitleSplit.length > 1) {
      for (let i = 1; i < itemTitleSplit.length; i++) {
        printer.addText(`${itemTitleSplit[i]}\n`)
      }
    }
    // 處理規格
    printer.addFeedUnit(12) // 垂直間隔
    const itemSpecSplit = getStringArray(currentItem.displaySpec, fontSetting.fontA.leftSideUnits)
    for (let i = 0; i < itemSpecSplit.length; i++) {
      printer.addText(`${itemSpecSplit[i]}\n`)
    }
    printer.addText(`${getContents('.', fontSetting.fontA.unitsPerLine / 0.5)}\n`) // 加入分隔線
    printer.addFeedUnit(4) // 垂直間隔
  }
  printer.addTextAlign(printer.ALIGN_RIGHT)
  printer.addText(`合計：${data.totalPoint}\n`)
  printer.addFeedUnit(48) // 垂直間隔

  printer.addTextAlign(printer.ALIGN_LEFT)
  printer.addText(`點數類型${getContents(' ', 14)}交易前 交易後\n`)
  printer.addFeedUnit(36) // 垂直間隔
  if (data.isPointSupplement) {
    // 啟用點數補足：顯示兩種點數
    printPointLine('一般點數', data.normalPointBefore, data.normalPointAfter)
    printer.addFeedUnit(16) // 垂直間隔
    printPointLine('現金點數', data.cashPointBefore, data.cashPointAfter)
  } else {
    // 未啟用點數補足：根據選擇的點數類型顯示
    const pointType = data.selectedPointType === 1 ? '一般點數' : '現金點數'
    const before = data.selectedPointType === 1 ? data.normalPointBefore : data.cashPointBefore
    const after = data.selectedPointType === 1 ? data.normalPointAfter : data.cashPointAfter
    printPointLine(pointType, before, after)
  }

  printer.addFeedUnit(12) // 垂直間隔
  printer.addText(`${getContents('-', fontSetting.fontA.unitsPerLine / 0.5)}\n`) // 加入分隔線
  printer.addFeedUnit(24) // 垂直間隔
  printer.addText(`${data.isVoidOrCancel ? '作廢/取消備註' : '備註'}：${data.note}\n`)
  printer.addFeedUnit(24) // 垂直間隔
  printer.addText(`時間：${data.date}\n`)
  printer.addFeedUnit(24) // 垂直間隔
  printer.addText(`簽名：${getContents('_', 20)}\n`)

  printer.addCut(printer.CUT_FEED)
  printer.send()

  console.log('Print done!')
}

/**
 * 生成一個包含指定內容與重複指定次數的字符串
 * @param {string} content - 要重複的內容。
 * @param {number} count - 重複內容的次數。
 * @returns {string} 包含重複內容的字符串。
 */
const getContents = (content, count) => {
  return Array(count).fill(content).join('')
}

/**
 * 取得字串陣列
 * @param {string} str 要拆解的字串
 * @param {number} unitsPerLine 每行的單位數
 * @returns {string[]} 拆解後的字串陣列
 */
const getStringArray = (str, unitsPerLine) => {
  const result = [] // 結果陣列
  let currentLine = '' // 目前行
  let currentLineUnits = 0 // 目前行的單位數

  for (let i = 0; i < str.length; i++) {
    const char = str[i] // 目前字元
    const charUnits = /[\u4e00-\u9fa5]/.test(char) ? 1 : 0.5 // 目前字元的單位數

    if (currentLineUnits + charUnits > unitsPerLine) {
      result.push(currentLine)
      currentLine = char
      currentLineUnits = charUnits
    } else {
      currentLine += char
      currentLineUnits += charUnits
    }
  }

  if (currentLine) {
    result.push(currentLine)
  }

  return result
}

/**
 * 取得字串單位數
 * @param {string} str 要計算的字串
 */
const getStringUnits = (str) => {
  return str.split('').reduce((acc, cur) => {
    return acc + (/[\u4e00-\u9fa5]/.test(cur) ? 1 : 0.5)
  }, 0)
}
